import type { ComponentNameAndModule } from '@sitecore-jss/sitecore-jss-angular';

const loadChildren = () =>
  import('./lib/emobility-app-store-redirect-lazy.module').then(
    (mod) => mod.EmobilityAppStoreRedirectLazyModule
  );

export const emobilityAppStoreRedirectLazyImports: ComponentNameAndModule[] = [
  {
    path: 'EmobilityAppStoreRedirect',
    loadChildren,
  },
];
